// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputBlock__V4JrU {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.inputHeader__mSzPu {
  position: relative;
  margin-bottom: 5px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.inputWrapper__jbf90 {
  position: relative;
}

.inputField__JbYl2 {
  font-family: "Roboto", sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
  width: 100%;
  padding: 0px 15px;
  border-radius: 2px;
  outline: none;
  color: var(--inputs-filled-text);
  border: 1px solid var(--inputs-default-stroke);
  background: var(--inputs-default-surface-default);
  height: 35px;
}
.inputField__JbYl2:active {
  border: 1px solid var(--inputs-focus-stroke);
  background: var(--inputs-default-surface-default);
}
.inputField__JbYl2:focus-visible {
  border: 1px solid var(--inputs-focus-stroke);
  background: var(--inputs-default-surface-default);
}
.inputField__JbYl2::placeholder {
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 12px;
  letter-spacing: 0%;
  color: var(--inputs-default-text);
}
.inputField__JbYl2:disabled {
  color: var(--inputs-disable-text);
  border: unset;
  background: var(--inputs-disable-disable-surface);
}

.inputFilledField__x4wmR {
  border: 1px solid var(--inputs-filled-stroke);
  background: var(--inputs-filled-filled-surface);
}

.inputErrorField__L8pGY {
  border: 1px solid var(--inputs-error-stroke);
  background: var(--inputs-error-error-surface);
}

.leftIndent__efPZc {
  padding-left: 25px;
}

.rightIndent__aqCKN {
  padding-right: 35px;
  text-overflow: ellipsis;
}

.inputFieldRtl__mBBiz {
  direction: rtl;
}

.helperText__keosh {
  color: var(--inputs-error-text-helper);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  margin-top: 5px;
  min-height: 12px;
}
@media (max-width: 850px) {
  .helperText__keosh {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}

.label__ZjJw8 {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.required__hKvZS:after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: 4px;
}

.extraElement__As9ib {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
}

.extraElementLeft__hg_TN {
  left: 15px;
}

.extraElementRight__aKxAb {
  right: 15px;
}

.inputDetailsWrapper__V4tNW {
  margin-left: auto;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.inputDetailsIcon__Gq7Zu {
  width: 100%;
  height: 100%;
  fill: var(--buttons-surface);
}

.inputDetails__xU4IF {
  max-width: 453px;
  padding: 8px !important;
  opacity: 1 !important;
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 4px !important;
  text-align: left !important;
}`, "",{"version":3,"sources":["webpack://./../src/components/uikit/Input/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,kBAAA;AAzEF;;AA4EA;EACE,iCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,gCAAA;EACA,8CAAA;EACA,iDAAA;EACA,YAAA;AAzEF;AA2EE;EACE,4CAAA;EACA,iDAAA;AAzEJ;AA4EE;EACE,4CAAA;EACA,iDAAA;AA1EJ;AA6EE;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;AA3EJ;AA8EE;EACE,iCAAA;EACA,aAAA;EACA,iDAAA;AA5EJ;;AAgFA;EACE,6CAAA;EACA,+CAAA;AA7EF;;AAgFA;EACE,4CAAA;EACA,6CAAA;AA7EF;;AAgFA;EACE,kBAAA;AA7EF;;AAgFA;EACE,mBAAA;EACA,uBAAA;AA7EF;;AAgFA;EACE,cAAA;AA7EF;;AAgFA;EACE,sCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AA7EF;AA+EE;EATF;IAUI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EA5EF;AACF;;AA+EA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA5EF;;AAgFE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AA7EJ;;AAiFA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;AA9EF;;AAiFA;EACE,UAAA;AA9EF;;AAiFA;EACE,WAAA;AA9EF;;AAiFA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AA9EF;;AAiFA;EACE,WAAA;EACA,YAAA;EACA,4BAAA;AA9EF;;AAiFA;EACE,gBAAA;EArKA,uBAAA;EACA,qBAAA;EACA,mDAAA;EACA,6BAAA;EACA,2BAAA;AAwFF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.inputBlock {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.inputHeader {\n  position: relative;\n  margin-bottom: 5px;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.inputWrapper {\n  position: relative;\n}\n\n.inputField {\n  font-family: 'Roboto', sans-serif;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 12px;\n  width: 100%;\n  padding: 0px 15px;\n  border-radius: 2px;\n  outline: none;\n  color: var(--inputs-filled-text);\n  border: 1px solid var(--inputs-default-stroke);\n  background: var(--inputs-default-surface-default);\n  height: 35px;\n\n  &:active {\n    border: 1px solid var(--inputs-focus-stroke);\n    background: var(--inputs-default-surface-default);\n  }\n\n  &:focus-visible {\n    border: 1px solid var(--inputs-focus-stroke);\n    background: var(--inputs-default-surface-default);\n  }\n\n  &::placeholder {\n    font-family: 'Roboto', sans-serif;\n    font-weight: 500;\n    font-size: 11px;\n    line-height: 12px;\n    letter-spacing: 0%;\n    color: var(--inputs-default-text);\n  }\n\n  &:disabled {\n    color: var(--inputs-disable-text);\n    border: unset;\n    background: var(--inputs-disable-disable-surface);\n  }\n}\n\n.inputFilledField {\n  border: 1px solid var(--inputs-filled-stroke);\n  background: var(--inputs-filled-filled-surface);\n}\n\n.inputErrorField {\n  border: 1px solid var(--inputs-error-stroke);\n  background: var(--inputs-error-error-surface);\n}\n\n.leftIndent {\n  padding-left: 25px;\n}\n\n.rightIndent {\n  padding-right: 35px;\n  text-overflow: ellipsis;\n}\n\n.inputFieldRtl {\n  direction: rtl;\n}\n\n.helperText {\n  color: var(--inputs-error-text-helper);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  margin-top: 5px;\n  min-height: 12px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n\n.label {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.required {\n  &:after {\n    content: '*';\n    font-size: 10px;\n    line-height: 12px;\n    color: var(--inputs-error-text-helper);\n    margin-left: 4px;\n  }\n}\n\n.extraElement {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-flex;\n}\n\n.extraElementLeft {\n  left: 15px;\n}\n\n.extraElementRight {\n  right: 15px;\n}\n\n.inputDetailsWrapper {\n  margin-left: auto;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.inputDetailsIcon {\n  width: 100%;\n  height: 100%;\n  fill: var(--buttons-surface);\n}\n\n.inputDetails {\n  max-width: 453px;\n  @include tooltip;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputBlock": `inputBlock__V4JrU`,
	"inputHeader": `inputHeader__mSzPu`,
	"inputWrapper": `inputWrapper__jbf90`,
	"inputField": `inputField__JbYl2`,
	"inputFilledField": `inputFilledField__x4wmR`,
	"inputErrorField": `inputErrorField__L8pGY`,
	"leftIndent": `leftIndent__efPZc`,
	"rightIndent": `rightIndent__aqCKN`,
	"inputFieldRtl": `inputFieldRtl__mBBiz`,
	"helperText": `helperText__keosh`,
	"label": `label__ZjJw8`,
	"required": `required__hKvZS`,
	"extraElement": `extraElement__As9ib`,
	"extraElementLeft": `extraElementLeft__hg_TN`,
	"extraElementRight": `extraElementRight__aKxAb`,
	"inputDetailsWrapper": `inputDetailsWrapper__V4tNW`,
	"inputDetailsIcon": `inputDetailsIcon__Gq7Zu`,
	"inputDetails": `inputDetails__xU4IF`
};
module.exports = ___CSS_LOADER_EXPORT___;
